import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetTemplates(type, start, limit) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/",
        params: { type, start, limit },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetGroupTemplate(templateId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/group/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetProjectTemplate(templateId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/project/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetTaskTemplate(templateId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/task/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetChecklistTemplate(templateId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/checklist/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateChecklistTemplate(templateData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/checklist",
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateChecklistTemplate(templateId, templateData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/templates/checklist/" + templateId,
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteChecklistTemplate(templateId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/templates/checklist/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetQuoteTemplate(templateId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/quote/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateQuoteTemplate(templateData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/quote",
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateQuoteTemplate(templateId, templateData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/templates/quote/" + templateId,
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteQuoteTemplate(templateId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/templates/quote/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateQuoteTemplateFromQuote(quoteId, data) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/quote/from-quote/" + quoteId,
        data,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateGroupTemplate(templateData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/group",
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateProjectTemplate(templateData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/project",
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateTaskTemplate(templateData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/task",
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateGroupTemplate(templateId, templateData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/templates/group/" + templateId,
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateProjectTemplate(templateId, templateData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/templates/project/" + templateId,
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateTaskTemplate(templateId, templateData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/templates/task/" + templateId,
        data: templateData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteGroupTemplate(templateId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/templates/group/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteProjectTemplate(templateId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/templates/project/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteTaskTemplate(templateId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/templates/task/" + templateId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestExecuteGroupTemplate(templateId, options) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/group/" + templateId + "/execute",
        data: options,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestExecuteProjectTemplate(templateId, options) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/project/" + templateId + "/execute",
        data: options,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetTemplateImportSource(sourceType, sourceId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/templates/import-source",
        params: { type: sourceType, id: sourceId },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestImportTemplate(body) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/templates/import",
        data: body,
        withCredentials: true,
        crossorigin: true
    });
}
